export default __webpack_public_path__ + "static/estimator-home_improvement-be7abb854335043fd682ce61845de834.svg";